import { render, staticRenderFns } from "./GuestOrderDetailsDialog.vue?vue&type=template&id=31c06980&scoped=true"
import script from "./GuestOrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./GuestOrderDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./GuestOrderDetailsDialog.vue?vue&type=style&index=0&id=31c06980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c06980",
  null
  
)

export default component.exports